var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmergency(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9961 15.9944H12.0061",
    stroke: "white",
    strokeWidth: 1.99929,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9961 7.99707V11.9956",
    stroke: "white",
    strokeWidth: 1.99929,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3063 1.99927C15.8365 1.99938 16.3449 2.21009 16.7198 2.58506L21.4061 7.27139C21.7811 7.64625 21.9918 8.15469 21.9919 8.68489V15.3065C21.9918 15.8367 21.7811 16.3452 21.4061 16.72L16.7198 21.4064C16.3449 21.7813 15.8365 21.9921 15.3063 21.9922H8.68465C8.15445 21.9921 7.646 21.7813 7.27115 21.4064L2.58482 16.72C2.20985 16.3452 1.99914 15.8367 1.99902 15.3065V8.68489C1.99914 8.15469 2.20985 7.64625 2.58482 7.27139L7.27115 2.58506C7.646 2.21009 8.15445 1.99938 8.68465 1.99927H15.3063Z",
    stroke: "white",
    strokeWidth: 1.99929,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmergency);
export default __webpack_public_path__ + "static/media/Emergency.405f72b7a5b00dedcf8eac8007a49341.svg";
export { ForwardRef as ReactComponent };